"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createKyveLCDClient = void 0;
var query_1 = require("./bundles/v1beta1/query");
var query_2 = require("./delegation/v1beta1/query");
var query_3 = require("./funders/v1beta1/query");
var query_4 = require("./global/v1beta1/query");
var query_5 = require("./pool/v1beta1/query");
var query_6 = require("./query/v1beta1/query");
var query_7 = require("./query/v1/query");
var query_8 = require("./stakers/v1/query");
var query_9 = require("./team/v1beta1/query");
var query_10 = require("./v1/bundles/query");
var query_11 = require("./multi_coin_rewards/v1/query");
var KyveLCDClient = /** @class */ (function () {
    function KyveLCDClient(restEndpoint) {
        this.v1 = {
            bundles: new query_10.V1BundlesLCDClient(restEndpoint),
        };
        this.bundles = {
            v1beta1: new query_1.BundlesModuleLCDClient(restEndpoint),
        };
        this.delegation = {
            v1beta1: new query_2.DelegationModuleLCDClient(restEndpoint),
        };
        this.funders = {
            v1beta1: new query_3.FundersModuleLCDClient(restEndpoint),
        };
        this.global = {
            v1beta1: new query_4.GlobalModuleLCDClient(restEndpoint),
        };
        this.pool = {
            v1beta1: new query_5.PoolModuleLCDClient(restEndpoint),
        };
        this.query = {
            v1beta1: new query_6.QueryModuleLCDClient(restEndpoint),
            v1: new query_7.QueryModuleV1LCDClient(restEndpoint),
        };
        this.stakers = {
            v1: new query_8.StakersModuleLCDClient(restEndpoint),
        };
        this.team = {
            v1beta1: new query_9.TeamModuleLCDClient(restEndpoint),
        };
        this.multi_coin_rewards = {
            v1: new query_11.MultiCoinRewardsModuleLCDClient(restEndpoint),
        };
    }
    return KyveLCDClient;
}());
function createKyveLCDClient(restEndpoint) {
    return {
        kyve: new KyveLCDClient(restEndpoint),
    };
}
exports.createKyveLCDClient = createKyveLCDClient;
//# sourceMappingURL=client.js.map